"use client";

import { type ReactNode } from "react";
import React from "react";

import { SignInModal } from "@/components/auth/SignInModal";
import { Button } from "@/components/ui/button";

interface SigninLinkButtonProps {
  children: ReactNode;
  /**
   * Full destination URL (path + search + hash) to redirect to after signin
   * Preferred method using type-safe deep linking (ADR-018)
   * @example "/listing/abc123?ref=email#place-bid"
   */
  destination?: string;
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
}

export function SigninLinkButton({
  children,
  variant = "default",
  size = "default",
  className,
  destination,
}: SigninLinkButtonProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setOpen(true)}
      >
        {children}
      </Button>
      <SignInModal
        open={open}
        onOpenChange={setOpen}
        destination={destination}
      />
    </>
  );
}

interface SigninLinkProps {
  children: ReactNode;
  /**
   * Full destination URL (path + search + hash) to redirect to after signin
   * Preferred method using type-safe deep linking (ADR-018)
   * @example "/listing/abc123?ref=email#place-bid"
   */
  destination?: string;
  className?: string;
}

export function SigninLink({
  children,
  destination,
  className,
}: SigninLinkProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <span className={className} onClick={() => setOpen(true)} style={{ cursor: "pointer" }}>
        {children}
      </span>
      <SignInModal
        open={open}
        onOpenChange={setOpen}
        destination={destination}
      />
    </>
  );
}
